import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/organization-user";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as RemoveRoute from "./remove";
import * as EditRoute from "./edit";
import { userParams } from "./params";

const LocalProvider = ({
  match: { params: raw },
  children: Children,
}) => {
  const {
    base: parentBase,
    basepath: parentBasepath,
    schema,
    // The parent section here is the organization query, so these are the
    // organization's values. Naming them `domain` — copied from the section one
    // level up, where that is what they are — put an object into `attributes`
    // under the same key as the :domain route param.
    values: organization,
  } = Section.useSectionContext();

  const params = userParams(raw);

  // Built from the raw segment, not the decoded address: this is a URL, and
  // every link below hangs off it.
  const base = `${parentBase}/${raw.email}`;
  const basepath = `${parentBasepath}/:email`;

  // Keyed on the entity, which is what the accidental remount used to do.
  //
  // Every screen below seeds its form state ONCE, from the entity this
  // route resolved. Until the render prop above was called rather than
  // rendered, React saw a new component type on every render and remounted
  // the lot — which reset those forms, and happened to be what made moving
  // from one email to another show the new one's values. It no longer
  // remounts for free, so the reset it was providing is asked for here.
  return (
    <Section.Provider
      key={raw.email}
      schema={schema}
      base={base}
      basepath={basepath}
      attributes={{ ...params, organization }}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export const Content = (props) => {
  return (
    <LocalProvider {...props}>
      {({ params: { domain, orgId, email } }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={{ domain, orgId, email }}
          datapath={"domains.get.organizations.get.users.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
};

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}/`} component={ViewRoute.Content} />
    </Switch>
  );
}

export const Sidebar = () => (
  <>
    <RemoveRoute.Sidebar />
    <EditRoute.Sidebar />
  </>
);

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { email } }) => (
        <>
          <Crumb to={`${base}`} label={email} />
          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}/`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}
